import { render, staticRenderFns } from "./newBadge.vue?vue&type=template&id=24240500&scoped=true"
import script from "./newBadge.vue?vue&type=script&lang=js"
export * from "./newBadge.vue?vue&type=script&lang=js"
import style0 from "./newBadge.vue?vue&type=style&index=0&id=24240500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24240500",
  null
  
)

export default component.exports